// 共通interface

// 切換列表顯示使用參數
export enum e_switchListsbBy {
    List = 'List', // 切換列表顯示
    Cards = 'Cards', // 切換個團顯示
}

// 判斷價錢為最小獲最大
export enum priceType {
    min = 'min',
    max = 'max',
}
export interface I_RootState {
    FilterItems?: I_FilterItem[];
    TempFilterItems?: I_FilterItem[];
    SortListBy?: number; // 排序
    TagList?: string; // 館別切換頁籤
    SwitchListBy?: string;
    TagFiltersShow?: string[];
    TempTagFiltersShow?: string[];
    CityLength: { [key: string]: number }; // 光箱國家裡城市的總數
    PackageInfo?: I_PackageInfo; // todo機票館別資料，未用到
    PopularInfo?: I_PopularInfo;
    AllCardsInfo: {
        // 卡牌
        DataList: I_CardsInfo_Common[];
    };
    RecommendsData: I_PopularInfo[]; // 推薦
    favList: I_FavList[]; // 收藏列表
    favPopUp: {
        state: I_FavPopUpState;
        show: boolean;
    }; // 收藏提示框
    FilterDataLoading: boolean; // 與m版卡牌元件有關
    sendEmitApi: boolean; // 是否發送api，光箱、m版勾選不會立刻發送用
}
export interface I_FilterItem {
    filterBy: string; // ui顯示名稱
    parentId: string; // 父層id名稱
    text: string; // 子項目ui名稱
    value: number | string; // 子項目id
    subValue: string; // 特殊情況用於判斷字串
}

// detail/PackageInfoJson (本日其他出發團與航班資訊)
export type I_PackageInfo = Array<I_GroupList>;

export interface I_GroupList {
    // todo此型別為機票館別元件用，目前沒用到
    GroupID: string; // 團號-團號公司
    IsEnsureGroup: boolean; // 是否為保證出團
    TotalSeats: number; // 總團位數
    QuotaSeats: number; // 可賣位數
    StraightLowestPrice: number; // 大人最低值售價
    IsVip: boolean; // 是否有會員限購價
    VipOrigPrice: number; // 會員限購價最低價
    Status: number; // 產品開發狀態： 1:報名, 2:候補, 3:額滿, 4:請洽專員, 5:關團(包含結團、鎖團、已截止), 6:近期上架
    StatusName: string; // 狀態名稱
    StatusClass: string; // 狀態等級
    ArriveTaiwanDate: string; // 抵達台灣時間
    DirectionList: Array<I_DirectionList>; // 航班資訊
}

export interface I_DirectionList {
    id: string; // 航班方向: 1:去程, 9:回程, O:中段, X:湊票不含此段
    Name: string; // 航班方向名稱: 1:去程, 9:回程, O:中段, X:湊票不含此段
    FlightList: Array<I_FlightList>;
}

export interface I_FlightList {
    DepartureDate: string; // 出發日期
    DepartTime: string; // 出發時間
    ArriveDate: string; // 抵達日期
    ArriveTime: string; // 抵達時間
    DepartureAirport: string; // 起飛機場
    ArriveAirport: string; // 抵達機場
    Airline: string; // 航空公司
    FlightNo: string; // 航班或班次編號
    FlightTime: string; // 飛行時間
}

// PopularInfoJson(推薦行程)
export interface I_PopularInfo {
    ProductName: string; // 行程名稱 ex: "玩樂369南北九州五日"
    ProductPrice: number; // 單團大人最低直客價 ex: 1900
    ProductURL: string;
    ProductType: string; //館別: 訂房、團體、自由行、票券
    ImageURL: string;
}

// 全產品新的interface 進階filter
export interface I_SearchAllFilterCommon {
    //所有館別都共用的資料
    PriceMax: number;
    PriceMin: number;
    DestinationList: any[]; //先給any 這邊是目的地資料陣列
    LightboxDestination: {
        //光箱全部目的地資料parentId 對應title跟子城市陣列
        // [key: string]: {};
        ParentTitle: string;
        values: any[];
        ParentId: string;
    }[];
}

//目的地篩選紀錄參數
export interface I_SelectedDestinationCommon {
    filterBy: any;
    text: any;
    value: string;
    subValue: string;
    parentId: string;
}

// 進階篩選紀錄共通
export interface I_FilterSelectedCommon {
    // Keyword: string; 這應該是共通(全域)的狀態，
    selectedPrices: number[];
    selectedDestinationID: I_SelectedDestinationCommon[];
    Page: number;
    PageSize: number;
}

// 全產品卡牌共通內容
export interface I_CardsInfo_Common {
    ImageURL: string;
    ProductURL: string;
    ProductType: string;
    ProductID: string;
    ProductName: string;
    SubType: number;
    DirectPrice: number;
    TradePrice: number;
    IsVip: number;
    Place: string;
    GoDate?: string; // 團體和機票使用
    AirportCabin?: string; // 機票使用
}

// 收藏list
export interface I_FavList {
    ProductID: string;
    ProductName: string;
    TravelType: number;
}

// 收藏提示框
export type I_FavPopUpState = 'addFav' | 'unFav';
